const env = {
    environment: process.env.NODE_ENV || 'development',
    storageUrl: import.meta.env.VITE_STORAGE_URL,
    baseUrl: import.meta.env.VITE_API_URL,
    socketUrl: import.meta.env.VITE_SOCKET_URL,
    stripeKey:import.meta.env.VITE_STRIPE_KEY,

}

export default env;
